// extracted by mini-css-extract-plugin
export default {"card":"CardForData_card__dDqGZ","cardTitle":"CardForData_cardTitle__Wvbxb","valueContainer":"CardForData_valueContainer__sfvCB","value":"CardForData_value__nzC0r"};